import { FunctionComponent, PropsWithChildren } from 'react';

// DebugProvider is currently a no-op wrapper so mounting is explicit at the
// app root. Items live in a module-level store (debugItemsStore) and enabled
// state lives in local storage (debugStorage), both consumed directly by
// DebugFloatingButton and useRegisterDebugItem.
export const DebugProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => <>{children}</>;
